<template>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        width: {
          name: 'width',
          defaultValue: 150,
          min: '350',
          max: '1500',
          labelDesc: 'height-content',
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + 'px';
          }
        },
        blogColor1: {
          name: 'blogColor1',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'ct-blog-color-1',
          callback: function() {
            vm.resources.blogColor1.defaultValue = this.colorValue;
            vm.element.internal_config.colors.color_1 = this.colorValue;
          }
        },
        blogColor2: {
          name: 'blogColor2',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'ct-blog-color-2',
          callback: function() {
            vm.resources.blogColor2.defaultValue = this.colorValue;
            vm.element.internal_config.colors.color_2 = this.colorValue;
          }
        },
        blogColor3: {
          name: 'blogColor3',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'ct-blog-color-3',
          callback: function() {
            vm.resources.blogColor3.defaultValue = this.colorValue;
            vm.element.internal_config.colors.color_3 = this.colorValue;
          }
        },
        blogTitleStyle: {
          name: 'blogTitleStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'ct-blog-title-style',
          callback: function() {
            vm.resources.blogTitleStyle.defaultFamily = this.family;
            vm.element.internal_config.styles.title.family = this.family;

            vm.resources.blogTitleStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.styles.title.size = this.size + 'px';

            vm.resources.blogTitleStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.styles.title.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogTitleStyle.defaultColor = this.color;
            vm.element.internal_config.styles.title.color = this.color;

            vm.resources.blogTitleStyle.defaultAlign = this.align;
            vm.element.internal_config.styles.title.align = this.align;

            vm.resources.blogTitleStyle.defaultWeight = this.weight;
            vm.element.internal_config.styles.title.weight = this.weight;

            vm.resources.blogTitleStyle.defaultStyle = this.style;
            vm.element.internal_config.styles.title.style = this.style;

            vm.resources.blogTitleStyle.defaultStroke = this.stroke;
            vm.element.internal_config.styles.title.stroke = this.stroke;
          }
        },
        blogAuthorStyle: {
          name: 'blogAuthorStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'ct-blog-author-style',
          callback: function() {
            vm.resources.blogAuthorStyle.defaultFamily = this.family;
            vm.element.internal_config.styles.author.family = this.family;

            vm.resources.blogAuthorStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.styles.author.size = this.size + 'px';

            vm.resources.blogAuthorStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.styles.author.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogAuthorStyle.defaultColor = this.color;
            vm.element.internal_config.styles.author.color = this.color;

            vm.resources.blogAuthorStyle.defaultAlign = this.align;
            vm.element.internal_config.styles.author.align = this.align;

            vm.resources.blogAuthorStyle.defaultWeight = this.weight;
            vm.element.internal_config.styles.author.weight = this.weight;

            vm.resources.blogAuthorStyle.defaultStyle = this.style;
            vm.element.internal_config.styles.author.style = this.style;

            vm.resources.blogAuthorStyle.defaultStroke = this.stroke;
            vm.element.internal_config.styles.author.stroke = this.stroke;
          }
        },
        blogCategoriesStyle: {
          name: 'blogCategoriesStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: false,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'ct-blog-author-style',
          callback: function() {
            vm.resources.blogCategoriesStyle.defaultFamily = this.family;
            vm.element.internal_config.styles.categories.family = this.family;

            vm.resources.blogCategoriesStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.styles.categories.size = this.size + 'px';

            vm.resources.blogCategoriesStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.styles.categories.sizeMobile = this.sizeMobile + 'px';

            vm.resources.blogCategoriesStyle.defaultColor = this.color;
            vm.element.internal_config.styles.categories.color = this.color;

            vm.resources.blogCategoriesStyle.defaultAlign = this.align;
            vm.element.internal_config.styles.categories.align = this.align;

            vm.resources.blogCategoriesStyle.defaultWeight = this.weight;
            vm.element.internal_config.styles.categories.weight = this.weight;

            vm.resources.blogCategoriesStyle.defaultStyle = this.style;
            vm.element.internal_config.styles.categories.style = this.style;

            vm.resources.blogCategoriesStyle.defaultStroke = this.stroke;
            vm.element.internal_config.styles.categories.stroke = this.stroke;
          }
        }
      }
    };
  },
  methods: {
    setMinValuesData(resource, value) {
      this.resources[resource].min = parseInt(value);
    },
    setValuesData(data) {
      this.element = data;
      let baseConfig = this.element.internal_config;

      this.resources.width.defaultValue = baseConfig.width;

      // colors
      this.resources.blogColor1.defaultValue = baseConfig.colors.color_1;
      this.resources.blogColor2.defaultValue = baseConfig.colors.color_2;
      this.resources.blogColor3.defaultValue = baseConfig.colors.color_3;

      // titleStyle
      this.resources.blogTitleStyle.defaultFamily = baseConfig.styles.title.family;
      this.resources.blogTitleStyle.defaultSize = baseConfig.styles.title.size;
      this.resources.blogTitleStyle.defaultSizeMobile = baseConfig.styles.title.sizeMobile;
      this.resources.blogTitleStyle.defaultColor = baseConfig.styles.title.color;
      this.resources.blogTitleStyle.defaultAlign = baseConfig.styles.title.align;
      this.resources.blogTitleStyle.defaultWeight = baseConfig.styles.title.weight;
      this.resources.blogTitleStyle.defaultStyle = baseConfig.styles.title.style;
      this.resources.blogTitleStyle.defaultStroke = baseConfig.styles.title.stroke;

      // author style
      this.resources.blogAuthorStyle.defaultFamily = baseConfig.styles.author.family;
      this.resources.blogAuthorStyle.defaultSize = baseConfig.styles.author.size;
      this.resources.blogAuthorStyle.defaultSizeMobile = baseConfig.styles.author.sizeMobile;
      this.resources.blogAuthorStyle.defaultColor = baseConfig.styles.author.color;
      this.resources.blogAuthorStyle.defaultAlign = baseConfig.styles.author.align;
      this.resources.blogAuthorStyle.defaultWeight = baseConfig.styles.author.weight;
      this.resources.blogAuthorStyle.defaultStyle = baseConfig.styles.author.style;
      this.resources.blogAuthorStyle.defaultStroke = baseConfig.styles.author.stroke;

      // categories style
      this.resources.blogCategoriesStyle.defaultFamily = baseConfig.styles.categories.family;
      this.resources.blogCategoriesStyle.defaultSize = baseConfig.styles.categories.size;
      this.resources.blogCategoriesStyle.defaultSizeMobile = baseConfig.styles.categories.sizeMobile;
      this.resources.blogCategoriesStyle.defaultColor = baseConfig.styles.categories.color;
      this.resources.blogCategoriesStyle.defaultAlign = baseConfig.styles.categories.align;
      this.resources.blogCategoriesStyle.defaultWeight = baseConfig.styles.categories.weight;
      this.resources.blogCategoriesStyle.defaultStyle = baseConfig.styles.categories.style;
      this.resources.blogCategoriesStyle.defaultStroke = baseConfig.styles.categories.stroke;
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Post/Resources.vue